module.exports = __webpack_public_path__ + "img/logo-en.b7d7001a.png";